module.exports = __webpack_public_path__ + "img/file-folder.4be398aa.svg";